/**
 * Scratch Drop campaign constants (BPES-237).
 *
 * Deliberately NOT added to `ProductMetafields` (`app/types/product.ts`): that enum doubles
 * as flash-sale *state* names and is spread wholesale into `FlashSaleStatus`, which
 * `flash-sale-layout.tsx` switches on. Adding scratch keys there would silently widen a
 * union that is about something else entirely.
 */

/** Shopify `custom` namespace metafield keys that drive the drop. */
export const ScratchMetafields = {
  /**
   * The colourway, 1-8, which also supplies `{n}` in the countdown title.
   *
   * Shopify sends this LABELLED -- "6 - Gray BG | Lime Images" -- so only the leading
   * integer is meaningful; see `resolveScratchDesignId`. A bare "6" is still accepted.
   */
  Design: 'scratch_design',
  /** ISO-8601 with a `Z`. The countdown target. */
  Date: 'scratch_date',
} as const;

export const SCRATCH_DESIGN_IDS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export type ScratchDesignId = (typeof SCRATCH_DESIGN_IDS)[number];

export const DEFAULT_SCRATCH_DESIGN_ID: ScratchDesignId = 1;

/**
 * Substituted into `SCRATCH_DROP_COUNTDOWN_TITLE` with the drop number, server-side.
 *
 * `{n}` and NOT `${n}`: dotenv-expand, most shells and several deploy dashboards substitute
 * `${...}` at read time, so a `${n}` template would silently arrive as `DROP  AVAILABLE FOR:`
 * — and only in production, since local dev reads the file differently. Case-insensitive
 * because somebody will eventually type `{N}` and a literal brace must never reach a live,
 * indexed page.
 */
export const SCRATCH_DROP_NUMBER_TOKEN = /\{n\}/gi;
